export default __webpack_public_path__ + "static/media/star.5e7a62d3.ico";